// extracted by mini-css-extract-plugin
export var readonly = "_ir-1";
export var star = "_ir-0";